export default "__VITE_ASSET__Dgh0sufr__"